module.exports = __webpack_public_path__ + "img/spiral-details20.e67366b6.png";